import React, { useMemo } from 'react';
import { Box, Typography, Container } from '@mui/material';
import { useGuestSpaceFavorites } from '../../hooks/useGuestSpaceFavorites';
import { SpacesList } from '../Search/components/SpacesList';
import { PreviewableSpace } from '../../components/SpacePreview';

export const FavoritesPage = () => {
  const { favoriteSpaces, loading } = useGuestSpaceFavorites();

  const mappedSpaces: PreviewableSpace[] = useMemo(() => {
    return favoriteSpaces.map((space) => ({
      images: space.images
        .filter((img) => img.url)
        .map((img) => ({ url: img.url as string })),
      seated: space.seated || undefined,
      standing: space.standing || undefined,
      pathname: space.pathname,
      name: space.name,
      slug: space.slug,
      venue: {
        liveAvailability: space.venue.liveAvailability,
        images: undefined,
        profileBanner: undefined,
        name: space.venue.name,
        slug: space.venue.slug,
        priceCategory: space.venue.priceCategory,
        address: space.venue.address
          ? {
              city: space.venue.address.city || '',
              state: space.venue.address.state || '',
            }
          : undefined,
      },
    }));
  }, [favoriteSpaces]);

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1">
          Favorites
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {favoriteSpaces.length > 0
            ? `You have ${favoriteSpaces.length} favorite space${favoriteSpaces.length > 1 ? 's' : ''}`
            : "You haven't favorited any spaces yet"}
        </Typography>
      </Box>
      <SpacesList spaces={mappedSpaces} loading={loading} />
    </Container>
  );
};
